import Breadcrumbs from '../components/shared/Breadcrumbs';

const DatenschutzPage = () => {
  return (
    <div className="py-12" data-testid="datenschutz-page">
      <div className="container-wide">
        <Breadcrumbs items={[{ label: 'Datenschutzerklärung', href: '/datenschutz' }]} />

        <div className="max-w-3xl">
          <h1 className="mb-8">Datenschutzerklärung</h1>

          <div className="prose-reviewlex">
            <section className="mb-8">
              <h2>1. Datenschutz auf einen Blick</h2>
              
              <h3>Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. 
                Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter 
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3>Datenerfassung auf dieser Website</h3>
              <p>
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
              </p>
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>
              <p>
                <strong>Wie erfassen wir Ihre Daten?</strong>
              </p>
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. 
                Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>
              <p>
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der 
                Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten 
                (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die 
                Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
              </p>
            </section>

            <section className="mb-8">
              <h2>2. Allgemeine Hinweise und Pflichtinformationen</h2>

              <h3>Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der 
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p>
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. 
                Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden 
                können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben 
                und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
              </p>
              <p>
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der 
                Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser 
                Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>

              <h3>Hinweis zur verantwortlichen Stelle</h3>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p>
                ReviewLex<br />
                [Adresse]<br />
                E-Mail: kontakt@reviewlex.de
              </p>
              <p>
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein 
                oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von 
                personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3>Speicherdauer</h3>
              <p>
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer 
                genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck 
                für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen 
                geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden 
                Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für 
                die Speicherung Ihrer personenbezogenen Daten haben.
              </p>
            </section>

            <section className="mb-8">
              <h2>3. Ihre Rechte</h2>
              
              <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger 
                und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben 
                außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. 
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese 
                Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, 
                unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen 
                Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen 
                Aufsichtsbehörde zu.
              </p>
              <p>
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit 
                an uns wenden.
              </p>

              <h3>Recht auf Datenübertragbarkeit</h3>
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in 
                Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten 
                in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die 
                direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt 
                dies nur, soweit es technisch machbar ist.
              </p>

              <h3>Auskunft, Löschung und Berichtigung</h3>
              <p>
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht 
                auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren 
                Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf 
                Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema 
                personenbezogene Daten können Sie sich jederzeit an uns wenden.
              </p>

              <h3>Recht auf Einschränkung der Verarbeitung</h3>
              <p>
                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen 
                Daten zu verlangen.
              </p>

              <h3>Widerspruch gegen Werbe-E-Mails</h3>
              <p>
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten 
                zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien 
                wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich 
                rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen vor.
              </p>
            </section>

            <section className="mb-8">
              <h2>4. Datenerfassung auf dieser Website</h2>

              <h3>Cookies</h3>
              <p>
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine 
                Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder 
                vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft 
                (permanente Cookies) auf Ihrem Endgerät gespeichert.
              </p>
              <p>
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies 
                informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies 
                für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen 
                der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von 
                Cookies kann die Funktionalität dieser Website eingeschränkt sein.
              </p>

              <h3>Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben 
                aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten 
                zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns 
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
                Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen 
                beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven 
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder 
                auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
              </p>
            </section>

            <section className="mb-8">
              <h2>5. Affiliate-Programme</h2>
              <p>
                Wir nehmen an Affiliate-Partnerprogrammen teil. Bei der Nutzung von Affiliate-Links 
                auf dieser Website (gekennzeichnet als Werbung oder mit einem entsprechenden Hinweis) 
                wird ein Cookie auf Ihrem Gerät gesetzt, das die Zuordnung einer Conversion 
                (z.B. Kaufabschluss) zu unserer Website ermöglicht.
              </p>
              <p>
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der 
                Websitebetreiber hat ein berechtigtes Interesse an der korrekten Abrechnung 
                seiner Affiliate-Vergütung. Sie können die Speicherung dieser Cookies durch 
                entsprechende Einstellung Ihrer Browser-Software verhindern.
              </p>
              <p>
                Weitere Informationen zu unseren Affiliate-Partnerschaften finden Sie in unserer 
                Affiliate-Offenlegung.
              </p>
            </section>

            <section className="mb-8">
              <h2>6. Plugins und Tools</h2>

              <h3>Google Fonts (lokal gehostet)</h3>
              <p>
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte 
                Google Fonts, die lokal auf unserem Server gehostet werden. Beim Aufruf einer 
                Seite werden keine Verbindungen zu Google-Servern hergestellt.
              </p>
            </section>

            <p className="text-sm text-slate-500 mt-12">
              Stand: April 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
